import { NgxCookiebotConfig } from '@halloverden/ngx-cookiebot';

export class CookiebotConfig extends NgxCookiebotConfig {
  override blockingMode = 'auto';
  override cdn = 'com';
  override framework = 'TCFv2.2';
  override loadScript = true;

  override cbId: string;
  override culture: string;

  constructor(cbId: string, culture: string) {
    super();
    this.cbId = cbId;
    this.culture = culture;
  }
}
